import React from 'react';
import { Link } from 'react-router-dom';
import { QueryButton } from '../../querybutton';
import StepsCarousel from '../homepage/stepcarausel';
import ServiceTabs from './posttab';

const PostConstruction = () => {
  return (
    <div className="font-sans text-gray-800">

      <QueryButton />

      {/* Banner Section */}



      <div className="rts-banner-area relative    py-8 md:py-12"
        style={{
          backgroundImage: "url('assets/images/banner/pcs.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundBlendMode: "overlay",
          width: "100vw"
        }}>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 "></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="title text-[#063970] text-4xl md:text-5xl font-bold mb-6">
              Post Construction Services
            </h1>

            <p className="text-lg md:text-xl text-[#000] mb-6">
              Streamlined construction sourcing to delivery
            </p>
            <Link to="/contact-us">
              <button className="px-6 py-2 bg-[#00A3A1] hover:bg-teal-600 text-white font-medium rounded-md transition duration-300">
                Request Quote
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Service Details Section */}
      <div className="service-details-area py-4">
        <div className="container mx-auto px-4">
          <div className="row flex flex-wrap">
            <div className="col-lg-12 w-full">
              <div className="service-details-inner-area-wrapper bg-white p-5 rounded-lg shadow-md">
                {/* Service 1: Final Inspection and Handover */}
                <div className="service-container flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-image mb-8 md:mb-0 md:mr-8 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/FIH.jpg"
                      alt="Final Inspection Process"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                  <div className="service-text">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Final Inspection & Project Handover
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      Our comprehensive handover process includes a detailed walkthrough with clients
                      to verify all work meets exacting quality standards. We document every detail in
                      a digital punch list, resolving all snag items before final acceptance. Using
                      advanced inspection tools, we ensure 100% compliance with specifications,
                      delivering buildings that exceed expectations. Clients receive a complete
                      quality certification with photographic evidence of all critical systems.
                    </p>
                  </div>
                </div>

                {/* Service 2: As-Built Documentation */}
                <div className="service-container-two flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-l from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-text-two order-2 md:order-1 md:mr-8">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Comprehensive As-Built Documentation
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      We deliver a complete digital twin package including BIM models, annotated
                      drawings, equipment manuals, and maintenance schedules. Our cloud-based
                      documentation system provides lifetime access to all construction records, with
                      QR code tagging for instant equipment identification. This living documentation
                      evolves with your facility, simplifying future renovations and ensuring optimal
                      system performance throughout the building lifecycle.
                    </p>
                  </div>
                  <div className="service-image-two order-1 md:order-2 mb-8 md:mb-0 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/TDB.jpg"
                      alt="As-Built Documentation"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                </div>

                {/* Service 3: Commissioning and Testing */}
                <div className="service-container flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-image mb-8 md:mb-0 md:mr-8 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/CTS.jpg"
                      alt="System Commissioning"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                  <div className="service-text">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Integrated Systems Commissioning
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      Our certified commissioning agents perform 200+ point checks on all mechanical,
                      electrical, and life safety systems. Using calibrated testing equipment, we
                      validate performance against design specifications, ensuring 100% operational
                      readiness. The process includes energy efficiency verification, load testing,
                      and fail-safe simulations, with all results documented in our proprietary
                      Building Performance Dashboard for ongoing monitoring.
                    </p>
                  </div>
                </div>

                {/* Service 4: Client Training */}
                <div className="service-container-two flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-l from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-text-two order-2 md:order-1 md:mr-8">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Comprehensive Facility Training
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      We provide customized training programs for facility teams, including hands-on
                      equipment demonstrations, digital O&M manuals, and emergency procedure
                      walkthroughs. Our training includes augmented reality guides for complex
                      systems, video tutorials for routine maintenance, and annual refresher courses.
                      Each participant receives certification upon completion, ensuring your team
                      maintains peak building performance long after handover.
                    </p>
                  </div>
                  <div className="service-image-two order-1 md:order-2 mb-8 md:mb-0 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/COT.jpg"
                      alt="Client Training Session"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                </div>

                {/* Service 5: Warranty Support */}
                <div className="service-container flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-image mb-8 md:mb-0 md:mr-8 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/DLWS.jpg"
                      alt="Warranty Support"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                  <div className="service-text">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Extended Warranty Protection
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      Our industry-leading warranty program includes 24/7 support with guaranteed
                      48-hour response times for critical issues. Beyond standard defect liability
                      periods, we offer optional extended warranties covering structural, mechanical,
                      and envelope systems. All warranty claims are managed through our online portal
                      with real-time tracking, and supported by our network of certified trade
                      partners for prompt, quality repairs.
                    </p>
                  </div>
                </div>

                {/* Service 6: Site Cleanup */}
                <div className="service-container-two flex flex-col md:flex-row items-center my-16 p-8 bg-gradient-to-l from-gray-50 to-white rounded-xl shadow-lg transition-all duration-400 overflow-hidden hover:shadow-xl">
                  <div className="service-text-two order-2 md:order-1 md:mr-8">
                    <h4 className="title text-2xl font-bold mb-4 relative pb-3 text-blue-900">
                      <span className="absolute bottom-0 left-0 w-16 h-1 bg-blue-500"></span>
                      Turnkey Site Completion
                    </h4>
                    <p className="disc text-base leading-relaxed text-[#000]">
                      Our white-glove cleanup process transforms construction sites into pristine,
                      move-in ready spaces. We implement eco-friendly waste management, deep cleaning
                      of all surfaces, and final aesthetic touch-ups. The process includes air quality
                      testing, window detailing, and landscape restoration. Clients receive a
                      cleanliness certification confirming the space meets hospitality-grade standards
                      before occupancy.
                    </p>
                  </div>
                  <div className="service-image-two order-1 md:order-2 mb-8 md:mb-0 overflow-hidden rounded-lg shadow-md flex-shrink-0 w-full md:w-1/2">
                    <img
                      src="assets/images/service/SCFT.jpg"
                      alt="Site Cleanup Process"
                      className="w-full h-64 object-cover transition-transform duration-500 hover:scale-103"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}

      <ServiceTabs/>

        {/* Call to Action Section */}
        <div className="rts-call-to-action py-8">
          <div className="container mx-auto px-4">
            <div className="row flex flex-wrap">
              <div className="col-lg-12 w-full">
                <div className="call-to-action-area-service bg-[#063970] text-white p-12 rounded-xl text-center">
                  <div className="inner">
                    <h3 className="title text-3xl font-bold mb-2">Ready to work together</h3>
                    <p className="disc text-lg mb-4 max-w-5xl mx-auto">
                      Whether you have a project in mind and you're looking for a reliable construction
                      partner or you're looking to take the next step in your career, we want to hear from
                      you!
                    </p>
                    <a href="/contact-us" className="rts-btn btn-primary inline-block bg-blue-500 hover:bg-[#00A3A1] text-white font-bold py-3 px-8 rounded-lg transition duration-300">
                      Make An Appointment
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <StepsCarousel />

    </div>
  );
};

export default PostConstruction;